import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'

import selectors from 'store/selectors'
import routerActions from 'store/modules/router'

const useStyles = makeStyles(theme => ({
 
}))

const NotFound = ({
  
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const visitHome = () => dispatch(routerActions.navigateTo('home'))

  return (
    <div>
      <div>page not found</div>
      <Button
        variant="contained"
        color="primary"
        onClick={ visitHome }
      >
        Home
      </Button>
    </div>
    
  )
}

export default NotFound